import styled from 'styled-components';

export const Container = styled.div`
  display: flex;

  margin-left: 3rem;
  gap: 1rem;
`;

export const LoadingUserInfo = styled.div`
  width: 350px;
`;

export const LoadingRepositoriesList = styled.div`
  width: 70%;
`;
